"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTitle = void 0;
var vue_1 = require("vue");
var CardType_1 = require("../../cards/CardType");
var CardCorporationLogo_1 = require("./CardCorporationLogo");
exports.CardTitle = vue_1.default.component('CardTitle', {
    props: {
        title: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
            validator: function (card) { return Object.values(CardType_1.CardType).includes(card); },
        },
    },
    components: {
        CardCorporationLogo: CardCorporationLogo_1.CardCorporationLogo,
    },
    methods: {
        isCorporation: function () {
            return this.type === CardType_1.CardType.CORPORATION;
        },
        isPrelude: function () {
            return this.type === CardType_1.CardType.PRELUDE;
        },
        getClasses: function (title) {
            var classes = ['card-title'];
            if (this.type === CardType_1.CardType.AUTOMATED) {
                classes.push('background-color-automated');
            }
            else if (this.type === CardType_1.CardType.ACTIVE) {
                classes.push('background-color-active');
            }
            else if (this.type === CardType_1.CardType.EVENT) {
                classes.push('background-color-events');
            }
            else if (this.type === CardType_1.CardType.PRELUDE) {
                classes.push('background-color-prelude');
            }
            else if (this.type === CardType_1.CardType.STANDARD_PROJECT || this.type === CardType_1.CardType.STANDARD_ACTION) {
                classes.push('background-color-standard-project');
            }
            var trimmedTitle = this.getCardTitleWithoutSuffix(title);
            if (trimmedTitle.length > 26) {
                classes.push('title-smaller');
            }
            else if (trimmedTitle.length > 23) {
                classes.push('title-small');
            }
            return classes.join(' ');
        },
        getMainClasses: function () {
            var classes = ['card-title'];
            if (this.type === CardType_1.CardType.STANDARD_PROJECT || this.type === CardType_1.CardType.STANDARD_ACTION) {
                classes.push('card-title-standard-project');
            }
            return classes.join(' ');
        },
        getCardTitleWithoutSuffix: function (title) {
            return title.split(':')[0];
        },
    },
    template: "\n      <div :class=\"getMainClasses()\">\n          <div v-if=\"isPrelude()\" class=\"prelude-label\">prelude</div>\n          <div v-if=\"isCorporation()\" class=\"corporation-label\">corporation</div>\n          <CardCorporationLogo v-if=\"isCorporation()\" :title=\"title\"/>\n          <div v-else :class=\"getClasses(title)\">{{ getCardTitleWithoutSuffix(title) }}</div>\n      </div>\n  ",
});
//# sourceMappingURL=CardTitle.js.map